import React from 'react';
import PropTypes from 'prop-types';
import superagent from 'superagent';
import styled from 'react-emotion';
import InterestingDistricts from './Components/InterestingDistricts';
import { Wrapper, Left, Middle, Right } from './Symbols/WidgetLayout';
import WidgetList from './Components/WidgetList';
import Head2Head from './Components/Head2HeadWidget';
import { Participation } from './Components/Head2HeadWidget/styles';
import { Button } from './Components/InterestingDistricts/styles';
import { sortBy } from './Utils/Sorters';

const Center = styled.div`
	text-align: center;
	width: 100%;
`;

const H2HWrapper = styled.div`
	${Participation} {
		display: none;
	}
`;

export default class App extends React.PureComponent {

	state = {
		interestingDistricts: [],
		finalists: [],
		meta: []
	}

	componentDidMount() {
		superagent
			.get(`${this.props.rootUrl}senate/${this.props.year}/vysledky_souhrn.json`)
			.then((data) => {
				const finalists = data.body.finalists.sort(sortBy(1, 'votes'));
				this.setState({
					interestingDistricts: (this.props.interestingDistricts || this.props.districts.slice(0, 3)).map(district => {
						return {
							...(data.body.leaders[0][district] || {}).area,
							names: finalists.filter(finalist => finalist.area.id === district).map(finalist => finalist.lastName),
						};
					}),
					meta: data.body.meta,
					finalists
				});
			}).catch(e => {
				console.error(e);
			});
	}

	componentDidUpdate() {
		if (this.props.onUpdate) {
			this.props.onUpdate();
		}
	}

	render() {
		return <Wrapper>
			<Left>
				<InterestingDistricts
					districts={this.state.interestingDistricts}
					link={this.props.linkToSenate}
					showMoreBtn={false}
				/>
			</Left>
			<Middle>
				<H2HWrapper>
					{this.state.finalists.length > 0 && this.state.meta.length > 0 && <Head2Head
						finalists={this.state.finalists}
						faces={this.props.faces}
						roundIndex={1}
						meta={this.state.meta[1]}
					/>}
				</H2HWrapper>
				<Center>
					<Button reverse href={this.props.linkToSenate}>
						Přehled všech obvodů
					</Button>
				</Center>

			</Middle>
			<Right>
				<WidgetList articles={this.props.articles} />
			</Right>
		</Wrapper>;
	}
}

App.propTypes = {
	rootUrl: PropTypes.string.isRequired,
	year: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.number
	]).isRequired,
	linkToSenate: PropTypes.string.isRequired,
	articles: PropTypes.arrayOf(PropTypes.object),
	interestingDistricts: PropTypes.arrayOf(PropTypes.number),
	faces: PropTypes.object.isRequired,
	onUpdate: PropTypes.func
};

App.defaultProps = {
	linkToSenate: '#'
}
